import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const I18nContext = createContext(null);

const getInitialLang = () => {
  if (typeof window === "undefined") return "it";
  return localStorage.getItem("rexxpons-lang") || "it";
};

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(getInitialLang);

  const setLang = useCallback((next) => {
    setLangState(next);
    try {
      localStorage.setItem("rexxpons-lang", next);
      document.documentElement.lang = next;
    } catch (e) {}
  }, []);

  const value = { lang, setLang, t: translations[lang] };
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
};
